class ProductQuantity {
    constructor() {
        this.quantityInput = document.querySelector('.qty-input');
        this.decreaseBtn = document.querySelector('[data-quantity-minus]');
        this.increaseBtn = document.querySelector('[data-quantity-plus]');
        this.addToCartBtn = document.querySelector('button[name="add"]');
        this.form = document.getElementById('product-form');
        this.loadingOverlay = document.querySelector('.qty-loading-overlay');

        this.init();
    }

    init() {
        if (this.decreaseBtn) {
            this.decreaseBtn.addEventListener('click', () => this.decreaseQuantity());
        }

        if (this.increaseBtn) {
            this.increaseBtn.addEventListener('click', () => this.increaseQuantity());
        }

        if (this.quantityInput) {
            this.quantityInput.addEventListener('change', () => this.validateQuantity());
        }

        if (this.form) {
            this.form.addEventListener('submit', (e) => this.handleAddToCart(e));
        }
    }

    decreaseQuantity() {
        const currentValue = parseInt(this.quantityInput.value);
        if (currentValue > 1) {
            this.quantityInput.value = currentValue - 1;
            this.validateQuantity();
        }
    }

    increaseQuantity() {
        const currentValue = parseInt(this.quantityInput.value);
        this.quantityInput.value = currentValue + 1;
        this.validateQuantity();
    }

    validateQuantity() {
        const value = parseInt(this.quantityInput.value);
        if (isNaN(value) || value < 1) {
            this.quantityInput.value = 1;
        }
    }

    async handleAddToCart(event) {
        event.preventDefault();

        if (!this.form) return;

        try {
            this.showLoading();

            const formData = new FormData(this.form);
            const response = await fetch('/cart/add.js', {
                method: 'POST',
                body: formData
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const data = await response.json();

            // Show success message
            this.showMessage('Product added to cart successfully!', 'success');

            // Update cart count if you have a cart count element
            this.updateCartCount();

            // Optional: Open cart drawer or redirect to cart page
            // window.location.href = '/cart';

        } catch (error) {
            console.error('Error:', error);
            this.showMessage('Failed to add product to cart. Please try again.', 'error');
        } finally {
            this.hideLoading();
        }
    }

    showLoading() {
        if (this.loadingOverlay) {
            this.loadingOverlay.style.display = 'flex';
        }
        if (this.addToCartBtn) {
            this.addToCartBtn.disabled = true;
        }
    }

    hideLoading() {
        if (this.loadingOverlay) {
            this.loadingOverlay.style.display = 'none';
        }
        if (this.addToCartBtn) {
            this.addToCartBtn.disabled = false;
        }
    }

    showMessage(message, type) {
        // Create message element if it doesn't exist
        let messageElement = document.querySelector('.cart-message');
        if (!messageElement) {
            messageElement = document.createElement('div');
            messageElement.className = 'cart-message';
            this.form.parentNode.insertBefore(messageElement, this.form.nextSibling);
        }

        // Set message content and type
        messageElement.textContent = message;
        messageElement.className = `cart-message ${type}`;

        // Remove message after 3 seconds
        setTimeout(() => {
            messageElement.remove();
        }, 3000);
    }

    updateCartCount() {
        // Fetch current cart count
        fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
                const cartCountElement = document.querySelector('.cart-count');
                if (cartCountElement) {
                    cartCountElement.textContent = cart.item_count;
                }
            })
            .catch(error => console.error('Error updating cart count:', error));
    }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
    new ProductQuantity();
}); 